/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.masterTools").
controller("DxSearchIndexRouteController", (function iife() {
	"use strict";

	function SearchIndexRouteController(
		$rootScope,
		$routeParams,
		$scope,

		Node,
		NodeRepository,
		dxSearchIndexService
	) {
		var self = this;

		// Attach to controller
		self.index = {
			name: $routeParams.indexName,
			count: 0,
			exists: false,
		};
		self.nodes = [];
		self.selectedNode = "";
		self.indexStatusLoaded = false;
		self.importFile = null;

		self.createIndex = createIndex;
		self.indexAll = indexAll;
		self.indexByOrg = indexByOrg;
		self.uploadFileAndIndexOrganizations = uploadFileAndIndexOrganizations;

		// Initialize
		indexStatus();
		getNodes();

		function indexStatus() {
			dxSearchIndexService.indexStatus(self.index.name).then(function onSuccess(response) {
				self.index = response.data;
				self.indexStatusLoaded = true;
			}, function onReject(response) {
				$rootScope.$broadcast("notification:error", response.data.msgs[0]);
			});
		}

		function createIndex() {
			dxSearchIndexService.createIndex(self.index.name).then(function onSuccess() {
				indexStatus();
				$rootScope.$broadcast("notification:success", "Index has been recreated");
			}, function onReject(response) {
				$rootScope.$broadcast("notification:error", response.data.msgs[0]);
			});
		}

		function getNodes() {
			NodeRepository.list().then(function success(data) {
				for (var i = 0; i < data.nodes.length; i++) {
					var node = new Node(data.nodes[i]);
					self.nodes.push(node);
				}
			});
		}

		function indexByOrg() {
			switch (self.index.name) {
				case dxSearchIndexService.indexType.INDEX_STUDENTS:
					dxSearchIndexService.indexStudentsInOrg(self.selectedNode.id).then(succeededAddingDocuments, errorAddingDocuments);
					break;
				case dxSearchIndexService.indexType.INDEX_JOBS:
					dxSearchIndexService.indexJobsInOrg(self.selectedNode.id).then(succeededAddingDocuments, errorAddingDocuments);
					break;
				default:
					break;
			}
		}

		function indexAll() {
			switch (self.index.name) {
				case dxSearchIndexService.indexType.INDEX_STUDENTS:
					dxSearchIndexService.indexAllStudents().then(succeededAddingDocuments, errorAddingDocuments);
					break;
				case dxSearchIndexService.indexType.INDEX_JOBS:
					dxSearchIndexService.indexAllJobs().then(succeededAddingDocuments, errorAddingDocuments);
					break;
				default:
					break;
			}
		}

		function succeededAddingDocuments() {
			$rootScope.$broadcast("notification:success", "Task to add documents to the search index has started");
		}

		function errorAddingDocuments(response) {
			$rootScope.$broadcast("notification:error", response.data.msgs[0]);
		}

		function uploadFileAndIndexOrganizations() {
			//Used in order to prevent race condition when file is removed
			if (self.importFile !== null) {
				dxSearchIndexService.sendCSVFile(self.index.name, self.importFile).then(succeededAddingDocuments, errorAddingDocuments);
			}
		}

		$scope.fileNameChanged = function fileNameChanged(ele) {
			self.importFile = null;
			if (ele.files.length > 0) {
				self.importFile = ele.files[0];
			}
		};
	}

	return SearchIndexRouteController;
}()));
